'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const dataAttr = (guard) => {
  return guard ? "" : void 0;
};
const ariaAttr = (guard) => {
  return guard ? "true" : void 0;
};

exports.ariaAttr = ariaAttr;
exports.dataAttr = dataAttr;
